import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, authHeaders, formatErr } from "./api";
import { inputCls, Field, TabCard } from "./fields";
import { Loader2, ShieldCheck } from "lucide-react";

export default function SecurityTab({ token, onUnauthorized }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 12) return toast.error("New password must be at least 12 characters.");
    if (next !== confirm) return toast.error("New passwords do not match.");
    setSaving(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: current, new_password: next, confirm_password: confirm }, authHeaders(token));
      toast.success("Password changed. Use it next time you log in.");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      if (err.response?.status === 401 && err.response?.data?.detail !== "Current password is incorrect") return onUnauthorized();
      toast.error(formatErr(err, "Could not change password."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <TabCard title="Security" sub="One admin user — credentials come from the server environment" testid="tab-security">
      <form onSubmit={submit} className="grid max-w-md gap-5">
        <Field label="Current password"><input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="security-current" className={inputCls} /></Field>
        <Field label="New password" hint="Minimum 12 characters"><input type="password" required minLength={12} value={next} onChange={(e) => setNext(e.target.value)} data-testid="security-new" className={inputCls} /></Field>
        <Field label="New password again"><input type="password" required minLength={12} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="security-confirm" className={inputCls} /></Field>
        <button type="submit" disabled={saving} data-testid="security-save"
          className="flex w-fit items-center gap-2 bg-myrtle px-7 py-3 text-xs uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:bg-myrtle-light disabled:opacity-60">
          {saving ? <Loader2 size={14} className="animate-spin" /> : <ShieldCheck size={14} />} Change Password
        </button>
      </form>
    </TabCard>
  );
}
